export default __webpack_public_path__ + "static/media/sz.d62f5eab.svg";